import React from 'react';
import { Helmet } from 'react-helmet-async';
import Product from './Product';

const Product_en = () => (
  <div className="lang-en">
    <Helmet>
      <title>Products</title>
      <meta
        name="description"
        content="Tang Wu Biotech offers five major product categories of premium catering ingredients for global food and beverage brands."
      />
      <meta name="keywords" content="products, food ingredients, catering" />
    </Helmet>
    <Product />
  </div>
);

export default Product_en;
